import React, { Fragment } from 'react';

const AppPageTitle = ({ onIconsButton, title }) => {
  return (
    <Fragment>
      <div className="px-7 w-full pb-1">
        <div className="flex justify-between items-center">
          <div className="my-auto">
            <div className="flex text-center my-auto">
              <h3 className="select-none font-semibold font-public-sans text-[13px] text-gray-700 dark:text-gray-500 my-auto">{title}</h3>
            </div>
          </div>
          {onIconsButton}
        </div>
      </div>
    </Fragment>
  );
};

export default AppPageTitle;
